function geocode(geocoder, request) {
  return new Promise((resolve) => {
    geocoder.geocode(request, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results === null) {
          return resolve({ status: 'ERROR', results: [] });
        }
        // resolve in OK state
        return resolve({ status: 'OK', results });
      }
      return resolve({ status, results: [] });
    });
  });
}
function googleAutocompleteHandler() {
  const geocoder = new google.maps.Geocoder();
  return async (userInput) => {
    const { status, results } = await geocode(geocoder, { address: userInput });
    if (status === 'OK') {
      const predictions = [];
      for (const responseItem of results) {
        predictions.push({
          description: responseItem.formatted_address,
          latitude: responseItem.geometry.location.lat(),
          longitude: responseItem.geometry.location.lng(),
        });
      }
      return { type: 'ok', data: predictions };
    }
    if (status === 'ZERO_RESULTS') {
      return { type: 'ok', data: [] };
    }
    if (status === 'INVALID_REQUEST') {
      return { type: 'error', message: `GOOGLE-API request is invalid (check request parameters)` };
    }
    if (status === 'REQUEST_DENIED') {
      return { type: 'error', message: `GOOGLE-API request was denied (check API key)` };
    }
    if (status === 'OVER_DAILY_LIMIT') {
      return { type: 'error', message: `GOOGLE-API daily request limit has been reached` };
    }
    if (status === 'OVER_QUERY_LIMIT') {
      return { type: 'error', message: `GOOGLE-API query request limit has been reached` };
    }
    return { type: 'error', message: `Unexpected GOOGLE-API response status` };
  };
}

function getGoogleMapsLink(store) {
  if (store.googleMapsLink) {
    return store.googleMapsLink;
  }
  return `https://www.google.com/maps?q=${encodeURI(
    `${store.address1} ${store.city} ${store.postalCode} ${store.province} ${store.country.name}`,
  )}`;
}

export { getGoogleMapsLink, googleAutocompleteHandler };
//# sourceMappingURL=index.es.js.map
